<template>
  <div class="the-navbar__user-meta flex items-center">
    <div class="text-right leading-tight hidden sm:block">
      <p v-if="user_displayName" class="font-semibold">
        {{ user_displayName }}
      </p>
      <p v-else class="font-semibold">User</p>
    </div>
    <vs-popup
      class="holamundo"
      title="Flairboat Support"
      :active.sync="active"
      background-color="rgba(255,255,255,.6)"
    >
      <vs-input
        v-validate="'required'"
        name="subject"
        icon="icon icon-edit-2"
        icon-pack="feather"
        label-placeholder="Subject"
        v-model="subject"
        class="w-full no-icon-border"
      />
      <span class="text-danger text-sm" v-show="errors.has('subject')">{{
        errors.first("subject")
      }}</span>

      <vs-textarea
        v-model="message"
        name="message"
        label="Your query..."
        class="mt-10 mb-0"
        rows="3"
        v-validate="'required'"
      />
      <span class="text-danger text-sm" v-show="errors.has('message')">{{
        errors.first("message")
      }}</span>
      <div class="mt-4 flex justify-center">
        <vs-button
          icon-pack="feather"
          icon="icon-send"
          icon-after
          @click.prevent="submit()"
          >Submit query</vs-button
        >
      </div>
    </vs-popup>
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img
          v-if="activeUserImg"
          key="onlineImg"
          :src="activeUserImg"
          alt="user-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
        <img
          v-else
          key="onlineImg"
          src="@/layouts/components/navbar/components/download.png"
          alt="user-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 12rem">
          <!--<li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/pages/profile').catch(() => {})">
            <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{ activeUserInfo.email }}</span>
          </li>-->

          <!--           
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="active= true">
            <feather-icon icon="SmileIcon" svgClasses="w-4 h-4" />
            <span class="ml-2"> Support</span>
            
          </li> -->

          <!-- <vs-divider class="m-1" /> -->

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

import { Validator } from "vee-validate";
const dict = {
  custom: {
    subject: {
      required: "Subject is required",
    },
    message: {
      required: "Message is required",
    },
  },
};

// register custom messages
Validator.localize("en", dict);
export default {
  props: {
    arr: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      active: false,
      subject: "",
      message: "",
      FullName: "",
      profilephoto: "",
      //arr:[]
    };
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    user_displayName() {
      return this.FullName || this.arr.FullName || this.arr.username;
    },
    activeUserImg() {
      return (
        this.profilephoto ||
        this.arr.profilephoto ||
        this.arr.photo ||
        this.$store.state.AppActiveUser.img
      );
    },
  },
  created() {
    const user = firebase.auth().currentUser;

    firebase
      .firestore()
      .collection("StudentID")
      .doc(user.uid)
      .get()
      .then((doc) => {
        this.FullName = doc.data().FullName;
        this.profilephoto = doc.data().profilephoto;
      });
    /* var u= firebase.auth().currentUser
        let role=this.$acl.get[0]
           const thisIns = this;
        if(role=='editor'){
            let collectionRef = firebase.firestore().collection('Students')
  let documents = collectionRef.get()
    .then(snapshot => {
      snapshot.forEach(doc => {
        //console.log("Parent Document ID: ", doc.id);
          const docid =doc.id
          
        let Docs = collectionRef.doc(doc.id).collection("Students")
                 Docs.doc(u.uid).get().then(doc=>{
                   if(doc.exists){
                     //console.log(docid)
                     thisIns.studentcode = docid
                     //console.log(thisIns.studentcode)
                     //this.student_code
                     thisIns.arr = doc.data()
                     //thisIns.notice
                   }
                 })
                 /*firebase.firestore().collection("CollegeCode").where("StudentCode","==", docid).onSnapshot(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
            thisIns.college = doc.data()
        })
                 })*/

    /*  })
    })
    
      } 
        if(role=='admin'){
            let collectionRef = firebase.firestore().collection('Colleges')
  let documents = collectionRef.get()
    .then(snapshot => {
      snapshot.forEach(doc => {
        //console.log("Parent Document ID: ", doc.id);
          const docid =doc.id 
        let Docs = collectionRef.doc(doc.id).collection("TPO")
                 Docs.doc(u.uid).get().then(doc=>{
                   if(doc.exists){
                     //console.log(docid)
                     thisIns.studentcode = docid
                     //console.log(thisIns.studentcode)
                     //this.student_code
                      thisIns.arr = doc.data()
                     // thisIns.notice
                   }
                 })

      })
    })
    
      }  */
  },
  methods: {
    submit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          var role = this.$acl.get[0];
          this.$vs.notify({
            color: "success",
            title: "Request Submitted Successfully",
            text:
              "Your query is important to us. We will get back to you soon!",
            time: 6000,
          });
          const user = firebase.auth().currentUser;
          firebase
            .firestore()
            .collection("SupportRequest")
            .doc(user.uid)
            .set(
              {
                subject: this.subject,
                message: this.message,
                email: user.email,
                role: role,
                timestamp: firebase.firestore.FieldValue.serverTimestamp(),
              },
              { merge: true }
            )
            .then(() => {
              this.message = "";
              this.subject = "";
              this.active = false;
            })
            .catch((err) => {
              console.log(err.message);
            });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Oops!",
            text: "Please fill in all the fields correctly !",
            time: 4000,
          });
        }
      });
    },
    logout() {
      // if user is logged in via auth0
      // if (this.$auth.profile) this.$auth.logOut();

      // if user is logged in via firebase
      const firebaseCurrentUser = firebase.auth().currentUser;

      if (firebaseCurrentUser) {
        firebase
          .auth()
          .signOut()
          .then(() => {
            this.$acl.change("editor");
            localStorage.removeItem("userInfo");
            localStorage.removeItem("jobpost");
            localStorage.removeItem("invoice");
            this.$router.push("/pages/login").catch(() => {});
          });
      }
      // If JWT login
      /*if(localStorage.getItem("accessToken")) {
          localStorage.removeItem("accessToken")
          this.$router.push('/pages/login').catch(() => {})
        }*/

      // Change role on logout. Same value as initialRole of acj.js
      // this.$acl.change('editor')
      // localStorage.removeItem('userInfo')

      // This is just for demo Purpose. If user clicks on logout -> redirect
      // this.$router.push('/pages/login').catch(() => {})
    },
  },
};
</script>
